import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BaseReport } from './BaseReport';

export class GeneralLedgerReport extends BaseReport {
    _originalTypeClassName = "zERP.BO.GeneralLedgerReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralLedgerReport.translate = translateService;
}
super();
this.Accounts = [];
this.TotalDebit = null;
this.TotalCredit = null;
this.TotalBalanceDebit = null;
this.TotalBalanceCredit = null;
this._key = this.BaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
TotalDebit:any;
TotalCredit:any;
TotalBalanceDebit:any;
TotalBalanceCredit:any;
Accounts:any;
static setAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Accounts == null) $this.Accounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Accounts.length > 0) {
                    Domain.GeneralLedgerReport.removeAccounts($this, $this.Accounts[0]);
                }

                Domain.GeneralLedgerReport.addManyAccounts($this, copyItems);
            }
static addManyAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralLedgerReport.addAccounts($this, items[i]);
                }
            }
static addAccounts = ($this, item) => {
                if ($this.Accounts == null) $this.Accounts = [];
                if (item == null || $this.Accounts.indexOf(item) > -1) return;
                $this.Accounts.push(item);
}
static addRangeAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralLedgerReport.addAccounts($this, item));
            }
static removeAccounts = ($this, item) => {
                if ($this == null || $this.Accounts == null || $this.Accounts.indexOf(item) === -1) return;
                var _index = $this.Accounts.indexOf(item);
                $this.Accounts.splice(_index, 1);
}
static clearAccounts = ($this) => { $this.Accounts = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BaseReportKey == null || $this.BaseReportKey == 0;
            }


}